import { useQuery } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { queryFnGET } from "api/tanStackQuery/helpers";
import { checklistQueryKey } from "features/CenterContent/RoleContent/VehicleChecklist/Checklist";
import {
  FillOuts,
  FillOutsSchema,
} from "features/CenterContent/RoleContent/VehicleChecklist/schema/responseSchema";
import useDebouncedValue from "shared/hooks/useDebouncedValue";

export default function useFillouts(autoCompletedQuery: string) {
  const [debouncedSearch] = useDebouncedValue(autoCompletedQuery, 300);

  return useQuery({
    queryKey: checklistQueryKey(debouncedSearch),
    queryFn: ({ signal }) =>
      queryFnGET<FillOuts>({
        signal,
        url: `${getBackendUrl()}/checklist/fill-outs/?query=${debouncedSearch}`,
      }).then((data) => FillOutsSchema.parse(data)),
    staleTime: 10,
    enabled: debouncedSearch.length > 1,
  });
}
